import * as types from "./types";
import {
    getEventListAxios,
    deleteEventAxios,
    postEventAxios,
    putEventAxios,
    getEventByIdAxios
} from "./services";

export async function getEventListAction({ commit }) {
    commit(types.LOADING_EVENT, true);
    try {
      const { data } = await getEventListAxios();
      commit(types.GET_EVENT_LIST, data.result.data);
    } catch (e) {
  
      throw e;
    } finally {
      commit(types.LOADING_EVENT, false);
    }
  }

  export async function removeEventAction({ commit }, payload) {
    commit(types.LOADING_EVENT, true);
    try {
      await deleteEventAxios(payload);
      commit(types.REMOVE_EVENT, payload);
    } catch (e) {
  
      throw e;
    } finally {
      commit(types.LOADING_EVENT, false);
    }
  }  

  export async function addEventAction({ commit }, payload) {
    commit(types.LOADING_EVENT, true);
    try {
      const { data } = await postEventAxios(payload);
      payload.id = data.result.id;
      commit(types.ADD_EVENT, payload);
    } catch (e) {
   
      throw e;
    } finally {
      commit(types.LOADING_EVENT, false);
    }
  }

  export async function updateEventAction({ commit }, payload) {
    commit(types.LOADING_EVENT, true);
    try {
      await putEventAxios(payload);
      commit(types.UPDATE_EVENT, payload);
    } catch (e) {
  
      throw e;
    } finally {
      commit(types.LOADING_EVENT, false);
    }
  }

  export async function getEventByIdAction({ commit }, payload) {
    commit(types.LOADING_EVENT, true);
    try {
        const { data } = await getEventByIdAxios(payload);
        commit(types.GET_EVENT_BYID, data.result);

    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EVENT, false);
    }
}